import { render } from "./Blog.vue?vue&type=template&id=6305a6b6&bindings={\"posts\":\"data\",\"getPosts\":\"options\"}"
import script from "./Blog.vue?vue&type=script&lang=js"
export * from "./Blog.vue?vue&type=script&lang=js"

import "./Blog.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script